import { action, payload } from 'ts-action'
import { ILocationVerificationEvidence } from 'models/LocationVerificationEvidence'
import { IError, IPayload } from '../../models/Global'

export const LocationVerificationEvidenceFetching = action(
  'LocationVerificationEvidenceFetching',
  payload<boolean>()
)

export const GetLocationVerificationEvidence = action(
  'GetLocationVerificationEvidence',
  payload<IPayload<ILocationVerificationEvidence[]>>()
)

export const GetLocationVerificationEvidenceErrors = action(
  'GetLocationVerificationEvidenceErrors',
  payload<IError>()
)
